import { Link } from 'react-router-dom';
import { Box, Button, Container, IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Logo from './Logo';
import AuthProductPanel from './AuthProductPanel';

const AuthPageLayout = ({
	children,
	headerRight,
	alignContent = 'center',
	dense = false,
	lockScroll = false,
}) => {
	return (
		<Box
			sx={{
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'flex-start',
				bgcolor: 'background.default',
			}}
		>
			<AuthProductPanel />

			<Box
				sx={{
					flex: 1,
					display: 'flex',
					flexDirection: 'column',
					minHeight: '100vh',
					maxHeight: { lg: lockScroll ? '100vh' : 'none' },
					overflow: 'auto',
				}}
			>
				<Box
					sx={{
						px: 2,
						py: dense ? 1 : 1.5,
						borderBottom: '1px solid',
						borderColor: 'divider',
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						flexShrink: 0,
					}}
				>
					<Tooltip title="Back to home">
						<IconButton
							component={Link}
							to="/"
							size="small"
							aria-label="Back to home"
						>
							<ArrowBackIcon />
						</IconButton>
					</Tooltip>
					<Logo
						sx={{
							height: 32,
							width: 'auto',
							display: { xs: 'block', lg: 'none' },
						}}
					/>
					{headerRight && <Box sx={{ ml: 'auto' }}>{headerRight}</Box>}
				</Box>

				<Box
					sx={{
						flex: 1,
						minHeight: 0,
						display: 'flex',
						flexDirection: 'column',
						justifyContent: {
							xs: 'flex-start',
							lg: alignContent === 'center' ? 'center' : 'flex-start',
						},
						overflow: 'auto',
					}}
				>
					<Container
						maxWidth="sm"
						sx={{
							py: dense ? { xs: 1.5, sm: 2 } : { xs: 3, sm: 4 },
							width: '100%',
						}}
					>
						{children}
					</Container>
				</Box>
			</Box>
		</Box>
	);
};

export const AuthHeaderLink = ({ to, children }) => (
	<Button component={Link} to={to} size="small">
		{children}
	</Button>
);

export default AuthPageLayout;
